/**
 * @flow
 * @relayHash c5e2a608d444cb815e22b1b9625ae5cd
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BackorderLineStatus = "FULFILLED" | "OPEN";
export type BackorderStatus = "CLOSED" | "FULFILLED" | "OPEN" | "PARTIALLY_FULFILLED";
export type Permission = "CREATE_API_KEY" | "CREATE_CUSTOMER" | "CREATE_INVOICE" | "CREATE_ITEM" | "CREATE_JOB" | "CREATE_LOT" | "CREATE_ORDER" | "CREATE_PAYMENT" | "CREATE_SHIPMENT" | "DELETE_API_KEY" | "DELETE_CUSTOMER" | "DELETE_INVOICE" | "DELETE_ITEM" | "DELETE_JOB" | "DELETE_LOT" | "DELETE_ORDER" | "DELETE_SHIPMENT" | "READ_API_KEY" | "READ_CUSTOMER" | "READ_INVOICE" | "READ_ITEM" | "READ_JOB" | "READ_LOT" | "READ_ORDER" | "READ_PAYMENT" | "READ_SHIPMENT" | "UPDATE_API_KEY" | "UPDATE_CUSTOMER" | "UPDATE_INVOICE" | "UPDATE_ITEM" | "UPDATE_JOB" | "UPDATE_LOT" | "UPDATE_ORDER" | "UPDATE_SHIPMENT";
export type BackorderQueryVariables = {|
  id?: ?string
|};
export type BackorderQueryResponse = {|
  +backorder: {|
    +id: string,
    +backorderNumber: string,
    +status: BackorderStatus,
    +expectedDate: ?any,
    +notes: ?string,
    +order: {|
      +id: string,
      +orderNumber: string,
    |},
    +customer: {|
      +id: string,
      +name: string,
    |},
    +lines: {|
      +edges: ?$ReadOnlyArray<?{|
        +node: {|
          +id: string,
          +orderedQuantity: number,
          +shippedQuantity: number,
          +backorderedQuantity: number,
          +fulfilledQuantity: number,
          +status: BackorderLineStatus,
          +item: {|
            +id: string,
            +name: string,
            +itemNumber: string,
          |},
          +createdAt: any,
        |}
      |}>
    |},
    +updatedAt: any,
    +createdAt: any,
  |},
  +viewer: ?{|
    +id: string,
    +permissions: $ReadOnlyArray<Permission>,
  |},
|};
export type BackorderQuery = {|
  variables: BackorderQueryVariables,
  response: BackorderQueryResponse,
|};
*/


/*
query BackorderQuery(
  $id: ID
) {
  backorder(id: $id) {
    id
    backorderNumber
    status
    expectedDate
    notes
    order {
      id
      orderNumber
    }
    customer {
      id
      name
    }
    lines(first: 1000) {
      edges {
        node {
          id
          orderedQuantity
          shippedQuantity
          backorderedQuantity
          fulfilledQuantity
          status
          item {
            id
            name
            itemNumber
          }
          createdAt
        }
      }
    }
    updatedAt
    createdAt
  }
  viewer {
    id
    permissions
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v5 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "backorder",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Backorder",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "backorderNumber",
        "args": null,
        "storageKey": null
      },
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "expectedDate",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "notes",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "order",
        "storageKey": null,
        "args": null,
        "concreteType": "Order",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "orderNumber",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "customer",
        "storageKey": null,
        "args": null,
        "concreteType": "Customer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/)
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "lines",
        "storageKey": "lines(first:1000)",
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 1000
          }
        ],
        "concreteType": "BackorderLineConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "BackorderLineEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "BackorderLine",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "orderedQuantity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shippedQuantity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "backorderedQuantity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fulfilledQuantity",
                    "args": null,
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "item",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "itemNumber",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "updatedAt",
        "args": null,
        "storageKey": null
      },
      (v4/*: any*/)
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "User",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "permissions",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "BackorderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v5/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "BackorderQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v5/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "BackorderQuery",
    "id": null,
    "text": "query BackorderQuery(\n  $id: ID\n) {\n  backorder(id: $id) {\n    id\n    backorderNumber\n    status\n    expectedDate\n    notes\n    order {\n      id\n      orderNumber\n    }\n    customer {\n      id\n      name\n    }\n    lines(first: 1000) {\n      edges {\n        node {\n          id\n          orderedQuantity\n          shippedQuantity\n          backorderedQuantity\n          fulfilledQuantity\n          status\n          item {\n            id\n            name\n            itemNumber\n          }\n          createdAt\n        }\n      }\n    }\n    updatedAt\n    createdAt\n  }\n  viewer {\n    id\n    permissions\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c5560da7eb4f2960e8d3063c8acd795c';
module.exports = node;
